// FAQ
$(".open-faq-header" ).click(function() {
  let menu_change = $(this).data("faqToggle")

  $(this).addClass("opened")
  $(".faq-header").not( $(this) ).removeClass("opened")
  $('.faq-text').addClass("hidden")

  $(".faq-toggle").not( $( `#${menu_change}` ) ).addClass("hidden")
  $( `#${menu_change}` ).toggleClass( "hidden" )
});

$(".faq-wrapper" ).click(function() {
  $('.faq-text').not($(this).children('.faq-text')).addClass("hidden")
  $('.angle-arrow.fa-angle-up').not($(this).children('.angle-arrow')).addClass("hidden")
  $('.angle-arrow.fa-angle-down').not($(this).children('.angle-arrow')).removeClass("hidden")
  $(this).children('.faq-text').toggleClass("hidden")
  $(this).children('.angle-arrow').toggleClass("hidden")
});


$( document ).ready(function() {
  let searchParams = new URLSearchParams(window.location.search)
  if (searchParams.has('anchor')){
    let param = searchParams.get('anchor')
    // Mobile layout (below Tailwind's lg breakpoint) uses a prefixed copy of each id
    let isMobile = !window.matchMedia('(min-width: 1024px)').matches
    let target = isMobile ? document.getElementById(`mobile-${param}`) : document.getElementById(param)
    let $target = $(target)
    if (target && !isMobile) {
      let $section = $target.closest('.faq-toggle')
      $(".faq-header").removeClass("opened")
      $(`.faq-header[data-faq-toggle="${$section.attr('id')}"]`).addClass("opened")
      $(".faq-toggle").addClass("hidden")
      $section.removeClass("hidden")
    }
    if (target) {
      $target.children('.faq-text').removeClass('hidden')
      $target.children('.angle-arrow').toggleClass('hidden')
      target.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }
  // Stop the propagation on the .faq-header click to prevent the toggling back
  $('.faq-text').click(function(event){
    event.stopPropagation();
  });
});
